import { forwardRef, useContext } from "react";
import { View as RNView } from "react-native";

import {
  LayoutContext,
  Text,
  View,
  XStack,
  YStack,
  useTheme,
} from "@/components";
import SectionHeader from "./SectionHeader";

type AtAGlanceItem = {
  Icon: React.ComponentType<{
    color: string;
    height: number;
    width: number;
    style?: any;
  }>;
  copy: string;
};

export type AtAGlanceProps = {
  headerTextInPrimaryColor: string;
  headerTextInBrandColor?: string;
  items: AtAGlanceItem[];
};

const AtAGlance = forwardRef<RNView, AtAGlanceProps>(
  ({ headerTextInPrimaryColor, headerTextInBrandColor, items }, ref) => {
    const iconColor = useTheme().textLink?.get();
    const { lg } = useContext(LayoutContext);

    const points = items.map(({ copy, Icon }) => (
      <>
        <XStack
          key={copy}
          alignItems="center"
          gap="$200"
          paddingVertical="$250"
        >
          <Icon
            color={iconColor}
            height={24}
            width={24}
            style={{ flexShrink: 0 }}
          />
          <Text>{copy}</Text>
        </XStack>
        <View
          width="100%"
          backgroundColor="$contentLoaderForeground"
          height={1}
        />
      </>
    ));

    if (lg) {
      return (
        <XStack
          maxWidth="$landingPageConstraint"
          alignSelf="center"
          paddingHorizontal="$250"
          gap="$800"
        >
          <View flex={1}>
            <SectionHeader
              ref={ref}
              textInPrimaryColor={headerTextInPrimaryColor}
              textInBrandColor={headerTextInBrandColor}
            />
          </View>
          <View flex={1}>{points}</View>
        </XStack>
      );
    }

    return (
      <YStack alignSelf="center" paddingHorizontal="$250">
        <SectionHeader
          ref={ref}
          textInPrimaryColor={headerTextInPrimaryColor}
          textInBrandColor={headerTextInBrandColor}
        />
        {points}
      </YStack>
    );
  },
);

export default AtAGlance;
